import { render } from "./helpPage.vue?vue&type=template&id=397f9918&scoped=true"
import script from "./helpPage.vue?vue&type=script&lang=js"
export * from "./helpPage.vue?vue&type=script&lang=js"

import "./helpPage.vue?vue&type=style&index=0&id=397f9918&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-397f9918"]])

export default __exports__